/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { CredentialDataModel } from './CredentialDataModel';
import { LinkedRef } from './LinkedRef';

export const Credential: core.serialization.ObjectSchema<serializers.Credential.Raw, Truvity.Credential> =
    core.serialization.object({
        dataModel: core.serialization.property('data_model', CredentialDataModel),
        digestMultibase: core.serialization.property('digest_multibase', core.serialization.string()),
        holder: core.serialization.string().optional(),
        id: core.serialization.string(),
        issuer: core.serialization.string(),
        linkedCredentialRefs: core.serialization.property(
            'linked_credential_refs',
            core.serialization.list(LinkedRef).optional(),
        ),
        linkedFileRefs: core.serialization.property('linked_file_refs', core.serialization.list(LinkedRef).optional()),
        type: core.serialization.list(core.serialization.string()),
        validFrom: core.serialization.property('valid_from', core.serialization.date()),
        validUntil: core.serialization.property('valid_until', core.serialization.date().optional()),
    });

export declare namespace Credential {
    export interface Raw {
        data_model: CredentialDataModel.Raw;
        digest_multibase: string;
        holder?: string | null;
        id: string;
        issuer: string;
        linked_credential_refs?: LinkedRef.Raw[] | null;
        linked_file_refs?: LinkedRef.Raw[] | null;
        type: string[];
        valid_from: string;
        valid_until?: string | null;
    }
}
